
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as feidegNxzz_45VgngLtK_LxYhFfbjgv56sFxdolzPxgwIIf9WEMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/feide.vue?macro=true";
import { default as index_BVcQ1rGq6Cs_DjzAOb3B5wZnk0V4uEwoz4o1ctpZKkMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/index.vue?macro=true";
import { default as personvernAZksb2sBH0cMb527t0dNKoMMqw_45iJNBHCckIZuTwqzUMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/personvern.vue?macro=true";
import { default as hvitlistingUTX3czeE0WFQhWWuaNi5MpQs_45R5hTHCay5zUAQEHcqYMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/hvitlisting.vue?macro=true";
import { default as rettigheterORiyxSe8MvfHhtX81PNoy_ALvxhQMnzu4lPt3mVRIWUMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/rettigheter.vue?macro=true";
import { default as bestill_45lisensahEPA5GO4rLOlUjOF20Cw90XkPmjjh5zhEv0nX8JFroMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/bestill-lisens.vue?macro=true";
import { default as lovlig_45redaksjon74z77VNwOp0RxShOYIqdm3vBpKnK4Be6g7mAtkgCjM4Meta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/lovlig-redaksjon.vue?macro=true";
import { default as universell_45utformingdCwBUPzHvMqej3xV4fSjJJb6_45hLpFUf_yac8lRQE0F0Meta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/universell-utforming.vue?macro=true";
import { default as index_45AHEY79GQDG3kpDedc8XSQ4_452XtAYVhb3_45KwjGcgPekMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/index.vue?macro=true";
import { default as indexfydEgLQ4HVJ_45xhjvaMFmr7sh47lR35isJKCxi_NbHcQMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/index.vue?macro=true";
import { default as indexel1bOhJn0vM_Rlx_45BIte9NmHgO_45NgZnazrA_45W4t_wP8Meta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/ressursbank/index.vue?macro=true";
import { default as _91subjectGuideSlug_936c0qOosDS9J84agmgEy6dSlWEa86HfSo7vB6RNtmvLYMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/laererveiledning/[subjectGuideSlug].vue?macro=true";
import { default as sokVb3fnWTDzemOwZF8z89ZRLfFzVLbGDZ8XIIQ7v9oewIMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/katalog/[catalogueSlug]/sok.vue?macro=true";
import { default as indexkMG_451TAHUIPaAMpFAThoC9acwJfcZQJcbCRoZ_45cdl8EMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/katalog/[catalogueSlug]/index.vue?macro=true";
import { default as _91catalogueTermSlug_93iqsXozEUFvxbFrPI3Eicv_45N7D_YJj5WzOpgM0bwVYWAMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/katalog/[catalogueSlug]/begrep/[catalogueTermSlug].vue?macro=true";
import { default as _91catalogueSlug_93qhjqIjFnoD0c1iKqaGYR8wEXLSUcB6jG7vKZAEb6KzoMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/katalog/[catalogueSlug].vue?macro=true";
import { default as _91subjectContentSlug_93XI7sjN71wb38PSzK4jl9xzS4KtVOPVtWQiKS6v_qMsIMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/fagtekst/[subjectContentSlug].vue?macro=true";
import { default as _91longtextSlug_93xAFXZPW_0vYgEUU4AJAJr7qILu_45KH1SDvAp_WrgCodsMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/[...path]/longtext/[longtextSlug].vue?macro=true";
import { default as _91topicGuideSlug_932dL6UKJFkXyryOfxyH3m1qsk70fQjs9_B6dCW1S18RYMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/laererveiledning/[topicGuideSlug].vue?macro=true";
import { default as indexLabXnS2iB0DPkCtX_OePK6zOY8tyPBbVd2BB3kETejsMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/fagressurs/[subjectResourceSlug]/index.vue?macro=true";
import { default as _91subjectResourceSlug_93XBOt66xVI9YTID1T5OVfx8DTyymiaLPLg_45eqD2Jj4pIMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/ressursbank/fagressurs/[subjectResourceSlug].vue?macro=true";
import { default as _91resourceGuideSlug_938WyUL6w9Hrla9Ia5V56aWi3y9WohRjkXuy8sy0ON8pUMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/[...path]/laererveiledning/[resourceGuideSlug].vue?macro=true";
import { default as _91collectionTaskSlug_93ci6_45F3De1Jko25OZVSnxWAvNH6ATD5p4l0_ohHAxQkkMeta } from "/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/fagressurs/[subjectResourceSlug]/collectiontask/[collectionTaskSlug].vue?macro=true";
export default [
  {
    name: "feide",
    path: "/feide",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/feide.vue")
  },
  {
    name: index_BVcQ1rGq6Cs_DjzAOb3B5wZnk0V4uEwoz4o1ctpZKkMeta?.name ?? "index",
    path: "/",
    meta: index_BVcQ1rGq6Cs_DjzAOb3B5wZnk0V4uEwoz4o1ctpZKkMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/index.vue")
  },
  {
    name: "personvern",
    path: "/personvern",
    meta: personvernAZksb2sBH0cMb527t0dNKoMMqw_45iJNBHCckIZuTwqzUMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/personvern.vue")
  },
  {
    name: "hvitlisting",
    path: "/hvitlisting",
    meta: hvitlistingUTX3czeE0WFQhWWuaNi5MpQs_45R5hTHCay5zUAQEHcqYMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/hvitlisting.vue")
  },
  {
    name: "rettigheter",
    path: "/rettigheter",
    meta: rettigheterORiyxSe8MvfHhtX81PNoy_ALvxhQMnzu4lPt3mVRIWUMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/rettigheter.vue")
  },
  {
    name: "bestill-lisens",
    path: "/bestill-lisens",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/bestill-lisens.vue")
  },
  {
    name: "lovlig-redaksjon",
    path: "/lovlig-redaksjon",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/lovlig-redaksjon.vue")
  },
  {
    name: "universell-utforming",
    path: "/universell-utforming",
    meta: universell_45utformingdCwBUPzHvMqej3xV4fSjJJb6_45hLpFUf_yac8lRQE0F0Meta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/universell-utforming.vue")
  },
  {
    name: index_45AHEY79GQDG3kpDedc8XSQ4_452XtAYVhb3_45KwjGcgPekMeta?.name ?? "fag-subjectSlug",
    path: "/fag/:subjectSlug()",
    meta: index_45AHEY79GQDG3kpDedc8XSQ4_452XtAYVhb3_45KwjGcgPekMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/index.vue")
  },
  {
    name: indexfydEgLQ4HVJ_45xhjvaMFmr7sh47lR35isJKCxi_NbHcQMeta?.name ?? "fag-subjectSlug-tema-topicSlug",
    path: "/fag/:subjectSlug()/tema/:topicSlug()",
    meta: indexfydEgLQ4HVJ_45xhjvaMFmr7sh47lR35isJKCxi_NbHcQMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/index.vue")
  },
  {
    name: "fag-subjectSlug-tema-topicSlug-ressursbank",
    path: "/fag/:subjectSlug()/tema/:topicSlug()/ressursbank",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/ressursbank/index.vue")
  },
  {
    name: _91subjectGuideSlug_936c0qOosDS9J84agmgEy6dSlWEa86HfSo7vB6RNtmvLYMeta?.name ?? "fag-subjectSlug-laererveiledning-subjectGuideSlug",
    path: "/fag/:subjectSlug()/laererveiledning/:subjectGuideSlug()",
    meta: _91subjectGuideSlug_936c0qOosDS9J84agmgEy6dSlWEa86HfSo7vB6RNtmvLYMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/laererveiledning/[subjectGuideSlug].vue")
  },
  {
    name: _91catalogueSlug_93qhjqIjFnoD0c1iKqaGYR8wEXLSUcB6jG7vKZAEb6KzoMeta?.name,
    path: "/fag/:subjectSlug()/tema/:topicSlug()/katalog/:catalogueSlug()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/katalog/[catalogueSlug].vue"),
    children: [
  {
    name: "fag-subjectSlug-tema-topicSlug-katalog-catalogueSlug-sok",
    path: "sok",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/katalog/[catalogueSlug]/sok.vue")
  },
  {
    name: "fag-subjectSlug-tema-topicSlug-katalog-catalogueSlug",
    path: "",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/katalog/[catalogueSlug]/index.vue")
  },
  {
    name: "fag-subjectSlug-tema-topicSlug-katalog-catalogueSlug-begrep-catalogueTermSlug",
    path: "begrep/:catalogueTermSlug()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/katalog/[catalogueSlug]/begrep/[catalogueTermSlug].vue")
  }
]
  },
  {
    name: _91subjectContentSlug_93XI7sjN71wb38PSzK4jl9xzS4KtVOPVtWQiKS6v_qMsIMeta?.name ?? "fag-subjectSlug-tema-topicSlug-fagtekst-subjectContentSlug",
    path: "/fag/:subjectSlug()/tema/:topicSlug()/fagtekst/:subjectContentSlug()",
    meta: _91subjectContentSlug_93XI7sjN71wb38PSzK4jl9xzS4KtVOPVtWQiKS6v_qMsIMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/fagtekst/[subjectContentSlug].vue")
  },
  {
    name: "fag-subjectSlug-tema-topicSlug-path-longtext-longtextSlug",
    path: "/fag/:subjectSlug()/tema/:topicSlug()/:path([^/]*)*/longtext/:longtextSlug()",
    meta: _91longtextSlug_93xAFXZPW_0vYgEUU4AJAJr7qILu_45KH1SDvAp_WrgCodsMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/[...path]/longtext/[longtextSlug].vue")
  },
  {
    name: _91topicGuideSlug_932dL6UKJFkXyryOfxyH3m1qsk70fQjs9_B6dCW1S18RYMeta?.name ?? "fag-subjectSlug-tema-topicSlug-laererveiledning-topicGuideSlug",
    path: "/fag/:subjectSlug()/tema/:topicSlug()/laererveiledning/:topicGuideSlug()",
    meta: _91topicGuideSlug_932dL6UKJFkXyryOfxyH3m1qsk70fQjs9_B6dCW1S18RYMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/laererveiledning/[topicGuideSlug].vue")
  },
  {
    name: indexLabXnS2iB0DPkCtX_OePK6zOY8tyPBbVd2BB3kETejsMeta?.name ?? "fag-subjectSlug-tema-topicSlug-fagressurs-subjectResourceSlug",
    path: "/fag/:subjectSlug()/tema/:topicSlug()/fagressurs/:subjectResourceSlug()",
    meta: indexLabXnS2iB0DPkCtX_OePK6zOY8tyPBbVd2BB3kETejsMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/fagressurs/[subjectResourceSlug]/index.vue")
  },
  {
    name: _91subjectResourceSlug_93XBOt66xVI9YTID1T5OVfx8DTyymiaLPLg_45eqD2Jj4pIMeta?.name ?? "fag-subjectSlug-tema-topicSlug-ressursbank-fagressurs-subjectResourceSlug",
    path: "/fag/:subjectSlug()/tema/:topicSlug()/ressursbank/fagressurs/:subjectResourceSlug()",
    meta: _91subjectResourceSlug_93XBOt66xVI9YTID1T5OVfx8DTyymiaLPLg_45eqD2Jj4pIMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/ressursbank/fagressurs/[subjectResourceSlug].vue")
  },
  {
    name: "fag-subjectSlug-tema-topicSlug-path-laererveiledning-resourceGuideSlug",
    path: "/fag/:subjectSlug()/tema/:topicSlug()/:path([^/]*)*/laererveiledning/:resourceGuideSlug()",
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/[...path]/laererveiledning/[resourceGuideSlug].vue")
  },
  {
    name: _91collectionTaskSlug_93ci6_45F3De1Jko25OZVSnxWAvNH6ATD5p4l0_ohHAxQkkMeta?.name ?? "fag-subjectSlug-tema-topicSlug-fagressurs-subjectResourceSlug-collectiontask-collectionTaskSlug",
    path: "/fag/:subjectSlug()/tema/:topicSlug()/fagressurs/:subjectResourceSlug()/collectiontask/:collectionTaskSlug()",
    meta: _91collectionTaskSlug_93ci6_45F3De1Jko25OZVSnxWAvNH6ATD5p4l0_ohHAxQkkMeta || {},
    component: () => import("/builds/aschehoug/aschehoug-utdanning/vgs-app/app/pages/fag/[subjectSlug]/tema/[topicSlug]/fagressurs/[subjectResourceSlug]/collectiontask/[collectionTaskSlug].vue")
  }
]